import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import dash_img from "../assets/images/man-with-laptop.png";
import { Button } from 'react-bootstrap';
import Footer from '../Footer/Footer';

const companyProfiles = [

  {
    id: 1,
    logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg",
    title: "Veritis Group Inc.",
    leads: 120,
    impressions: 200,
    rating: 4.8,
    tagline: "Innovating the Future",
    servicesCount: 10,
    productCount: 5,
    verified: true,
  },

  {
    id: 2,
    logo: "https://www.wipro.com/content/dam/wipro/social-icons/wipro_new_logo.svg",
    title: "Wipro",
    leads: 90,
    impressions: 50,
    rating: 4.7,
    tagline: "Your Digital Partner",
    servicesCount: 8,
    productCount: 3,
    verified: false,
  },


  {
    id: 3,
    logo: "https://v.fastcdn.co/u/573f0666/64658906-0-zd-primary-logo.svg",
    title: "ZenDesk Solutions Inc.",
    leads: 120,
    rating: 4.5,
    impressions: 125,
    tagline: "Innovating the Future",
    servicesCount: 10,
    productCount: 5,
    verified: true,
  },



];

const MainDashboard = () => {
  return (
    <>
    <div className="js-pg-hg mt-5">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-12">
          <div className="heading mb-4 pb-1">
            <h6 className="card-title text-primary mb-2">Welcome John!</h6>
            <h4>Your Company Profiles</h4>
          </div>




          <div className="row">
            {companyProfiles.map(company => (



              <div className="col-md-6 mb-4" key={company.id}>




<div className="card mx-2 mb-3 p-4 shadow-sm ls-profile rounded-4">
  <div className="d-flex flex-column flex-md-row justify-content-start align-items-md-start">
    <img
      src={company.logo}
      alt={company.title}
      className="me-md-3 mb-3 mb-md-0 border rounded p-3 align-self-center align-self-md-start"
      width="100"
      height="100"
    />
    <div className="ps-0 ps-md-2 w-100">
      <div className='d-flex justify-content-between'>
        <div>
      <h5 className="mb-1">
        <NavLink to="/CompanyProfile" className="text-black text-decoration-none">{company.title}</NavLink>
        <p className="text-muted p-0 m-0 small pt-2 mb-2">{company.tagline}</p>
      </h5>
      </div>
      <div>

      <span className="badge bg-success p-2 small text-white border-0 mb-2 d-inline-block">
          <i className='bx bxs-badge-check'></i> Verified
        </span>
        </div>
        </div>

      <p className="br-cm-rt mb-2">
        {company.rating}
        <i className='bx bxs-star'></i>
        <i className='bx bxs-star'></i>
        <i className='bx bxs-star'></i>
        <i className='bx bxs-star'></i>
        <i className='bx bxs-star'></i>
      </p>

      <div className="d-flex justify-content-between border-top py-2 num-stat my-3 border-bottom flex-wrap gap-3">
        <div className="my-1">Impressions <strong>{company.impressions}</strong></div>
        <div className="my-1">Services <strong>{company.servicesCount}</strong></div>
        <div className="my-1">Products <strong>{company.productCount}</strong></div>
      </div>


      <NavLink
        as={Link}
        to="/RequestOwnershipForm"
        className="btn text-decoration-none btn-link btn-sm p-0 text-primary d-block mt-2 text-start"
      >
        Claim this page
      </NavLink>
    </div>
  </div>
</div>



              </div>



            ))}
          </div>
          <div className="row mt-4">
          <div class="col-sm-12">
          <div class="card shadow-sm rounded-4">
        <div class="d-flex align-items-center row">
          <div class="col-sm-8">
            <div class="card-body px-4 mx-2">
              <h5 class="card-title text-primary mb-3">Review a Company</h5>
              <p class="mb-6">Leaving a review helps Comapany leaders like you make a confident choice.</p>


              <Button as={Link} to="/writereview" class="btn btn-primary">Write a Review</Button>
            </div>
          </div>
          <div class="col-sm-4 text-center text-sm-left">
            <div class="card-body pb-0 px-0 px-md-6">
              <img src={dash_img} height="175" class="scaleX-n1-rtl" alt="View Badge User" />
            </div>
          </div>
          </div>
        </div>
      </div>
      </div>

        </div>
      </div>

    </div>
    </div>
    <Footer />
    </>
  );
};

export default MainDashboard;
